import React from 'react';
import Loadable from 'react-loadable';
import Helmet from 'react-helmet';

const AsyncExploreFollowingRoute = Loadable({
  loader: () =>
    import(/* webpackChunkName: "explore_following" */ './AsyncExploreFollowingRoute.js'),
  loading: () => (
    <Helmet bodyAttributes={{ style: 'background-color: white;' }} />
  )
});

export default AsyncExploreFollowingRoute;
